import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { scrollToSection } from "../../../utils/scroll-to";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  imports: [RouterModule],
})
export class NavbarComponent {
  public scrollToSection(id?: string): void {
    if (id) {
      scrollToSection(id);
    }
  }
}
